var _path, _mask, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnStat = function SvgBtnStat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.898 5.894a.6.6 0 0 1-.326.784 6.701 6.701 0 0 0 2.557 12.893c2.799 0 5.198-1.717 6.2-4.157a.6.6 0 1 1 1.11.455 7.901 7.901 0 0 1-15.21-2.997A7.901 7.901 0 0 1 8.114 5.57a.6.6 0 0 1 .784.325Z",
    fill: "#7E8185"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "btn_stat_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12.404a.471.471 0 0 1-.478.466H12.13a1 1 0 0 1-1-1V4.479c0-.262.204-.479.465-.479A8.404 8.404 0 0 1 20 12.404Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.522 11.67H12.13v2.4h7.39v-2.4Zm-7.191.2V4.479h-2.4v7.39h2.4Zm-.735-6.67a7.204 7.204 0 0 1 7.204 7.204h2.4C21.2 7.1 16.9 2.8 11.596 2.8v2.4Zm.735-.721c0 .358-.291.721-.735.721V2.8c-.966 0-1.666.798-1.666 1.679h2.4Zm-.2 7.19c.11 0 .2.09.2.2h-2.4a2.2 2.2 0 0 0 2.2 2.2v-2.4Zm7.39 2.4c.881 0 1.68-.699 1.68-1.665h-2.4c0-.444.362-.734.72-.734v2.4Z",
    fill: "#7E8185",
    mask: "url(#btn_stat_svg__a)"
  })));
};
export default SvgBtnStat;